import { render, staticRenderFns } from "./deleteContractPartya.vue?vue&type=template&id=0cd88225&scoped=true"
import script from "./deleteContractPartya.vue?vue&type=script&lang=js"
export * from "./deleteContractPartya.vue?vue&type=script&lang=js"
import style0 from "./deleteContractPartya.vue?vue&type=style&index=0&id=0cd88225&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd88225",
  null
  
)

export default component.exports